import { CriterionDependenciesReadModel } from "@Criteria/Hierarchies/Domain/readmodels";

export class CriterionDeleterViewModel
{
    opened: boolean = false;

    criterionId: number | null = null;
    data: CriterionDependenciesReadModel | null = null;

    show(criterionId: number)
    {
        this.criterionId = criterionId;
        this.data = null;

        this.opened = true;
    }

    close()
    {
        this.opened = false;

        this.criterionId = null;
        this.data = null;
    }

    setData(data: CriterionDependenciesReadModel)
    {
        this.data = data;
    }
}